import React, { useMemo } from 'react';
import Builder from '@form-engine/builder-application';
import BuilderDrawerNav, {
    BuilderDrawerNavHeader,
    BuilderDrawerNavItem,
} from '@form-engine/builder-application/components/drawer-nav';
import { useFormPresetList } from '@form-engine/builder-application/hooks/use-form-preset-api';
import BuilderElementsDrawerPresetButton from './preset-button';
import { Spinner } from 'react-bootstrap';
import { FormPreset } from '@form-engine/core-application/types/form';
import { PencilFill } from 'react-bootstrap-icons';
import { useFormPresetDialog } from '../form-preset-dialog';

function PresetDrawerNavItem({ preset }: { preset: FormPreset }) {
    const openDialog = useFormPresetDialog();

    return (
        <BuilderDrawerNavItem
            button={BuilderElementsDrawerPresetButton}
            actions={
                <button onClick={() => openDialog(preset)}>
                    <PencilFill />
                </button>
            }
            buttonProps={{ preset }}
        />
    );
}

export default function BuilderElementsDrawer() {
    const drawerButtons = useMemo(
        () =>
            Object.values(Builder.elements)
                .filter((ns) => ns.Element.enabled)
                .map((ns) => ns.DrawerButton)
                .filter((Comp) => Boolean(Comp)),
        []
    );

    const presets = useFormPresetList();

    return (
        <BuilderDrawerNav>
            <BuilderDrawerNavHeader>Elements</BuilderDrawerNavHeader>
            {drawerButtons.map((Comp, index) => (
                <BuilderDrawerNavItem key={index} button={Comp} />
            ))}
            <BuilderDrawerNavHeader>
                <div className="d-flex justify-content-between">
                    <div>Presets</div>
                    <div>{presets.loading && <Spinner size="sm" />}</div>
                </div>
            </BuilderDrawerNavHeader>
            {presets?.state?.map((preset) => (
                <PresetDrawerNavItem key={preset.id} preset={preset} />
            ))}
        </BuilderDrawerNav>
    );
}
